import script from "./sysSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./sysSetting.vue?vue&type=script&setup=true&lang=js"

import "./sysSetting.vue?vue&type=style&index=0&id=e9c23f20&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\baoda\\salary\\wages-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9c23f20"]])

export default __exports__